/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */

/**
 * Created by kyang on 9/24/20
 */

function SamlLoginController (
    this: JS5Object,
    _: JS5Object,
    $window: JS5Object,
    EndPointService: JS5Object,
    LoginEditService: JS5Object,
) {
    this.login = () => {
        const url = '/packages';
        LoginEditService.navigateToApp();
        $window.open(`${EndPointService.samlEndPoint}?redirectUrl=${url}`, '_self');
    };
}

angular
    .module('prism-ui.login')
    .component('samlLogin', {
        controller: SamlLoginController,
        templateUrl: 'login/components/samlLogin/saml-login-template.html',
        bindings: {
            canSubmit: '<',
        }
    });
